/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PodIdsQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("PodIdsQueryOperator");
    }

    getFixupPrototypeFunction() { return PodIdsQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<PodIdsQueryOperator>): PodIdsQueryOperator {
        let obj = Object.assign(new PodIdsQueryOperator(), model);
        PodIdsQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PodIdsQueryOperator>): PodIdsQueryOperator {
        if (!model) return null;
        return PodIdsQueryOperator.newInstance(<PodIdsQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PodIdsQueryOperator) {
        if (!obj) return;

        models.PodIdsQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PodIdsQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, PodIdsQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Pod Ids to include
     */
    pod_ids: Array<string>;

}
